<template>
  <a-drawer
    :wrapClassName="$store.state.bgLight ? 'lightColor' : ''"
    :title="title"
    :width="1024"
    placement="right"
    :closable="true"
    @close="close"
    :visible="true"
    v-if="visible"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="基础信息" key="1">
            <a-row :gutter="24">
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="故障站点">
                  {{ siteName }}
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="故障来源">
                  <j-dict-select-tag
                    :triggerChange="true"
                    :defaultState="true"
                    dictCode="error_origin"
                    v-decorator="['originKey', validatorRules.originKey]"
                    placeholder="请选择故障来源"
                    :disabled="true"
                  ></j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务类型">
                  <j-dict-select-tag
                    dictCode="job_category"
                    v-decorator="['category', validatorRules.category]"
                    placeholder="请选择任务类型"
                    :triggerChange="true"
                    :defaultState="true"
                    :disabled="disableSubmit"
                  ></j-dict-select-tag>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务级别">
                  <j-dict-select-tag
                    dictCode="job_level"
                    v-decorator="['jobLevel', validatorRules.jobLevel]"
                    placeholder="请选择任务级别"
                    :triggerChange="true"
                    :defaultState="true"
                    :disabled="disableSubmit"
                  ></j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标题">
                  <a-input
                    placeholder="请输入标题"
                    v-decorator="['title', validatorRules.title]"
                    :disabled="disableSubmit"
                  />
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人员">
                  <a-tree-select
                    style="width: 100%"
                    :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                    :treeData="userTree"
                    :disabled="disableSubmit"
                    v-decorator="['userId', validatorRules.userId]"
                    placeholder="请选择处理人员"
                    dropdownClassName="selects"
                    show-search
                    treeNodeFilterProp="title"
                  >
                    <template slot="title" slot-scope="{ title }">
                      {{ title }}
                    </template>
                  </a-tree-select>
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备">
                  <a-select
                    style="width: 100%"
                    placeholder="请选择设备"
                    v-model="selectedAsset"
                    :disabled="disableSubmit"
                    :open="false"
                    @dropdownVisibleChange="selectAssets"
                  >
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="故障码">
                  <a-input placeholder="请输入故障码" v-decorator="['errorCode', {}]" :disabled="disableSubmit" />
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开始时间">
                  <a-date-picker
                    :show-time="true"
                    style="width: 100%"
                    ref="startTime"
                    format="YYYY-MM-DD HH:mm:ss"
                    v-decorator="['startTime', {}]"
                    :disabled="disableSubmit"
                  />
                </a-form-item>
              </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="截止时间">
                  <a-date-picker
                    :show-time="true"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    ref="endTime"
                    v-decorator="['endTime', {}]"
                    :disabled="disableSubmit"
                  />
                </a-form-item>
              </a-col>

              <a-col :md="24" :sm="24">
                <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="任务描述">
                  <a-textarea
                    :autoSize="{ minRows: 3, maxRows: 5 }"
                    placeholder="请输入任务描述"
                    v-decorator="['remark', {}]"
                    :disabled="disableSubmit"
                  />
                </a-form-item>
              </a-col>
              <a-divider v-if="(disableSubmit&&!showCheck)|| disableSubmit"></a-divider>
              <div v-if="disableSubmit&&!showCheck">
                <a-col :md="12" :sm="24" v-if="model.status > 1">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开始处理时间">
                    <a-date-picker
                      :show-time="true"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      ref="processingTime"
                      v-decorator="['processingTime', {}]"
                      disabled
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="12" :sm="24" v-if="model.status > 2">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="完成时间">
                    <a-date-picker
                      :show-time="true"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      ref="completionTime"
                      v-decorator="['completionTime', {}]"
                      disabled
                    />
                  </a-form-item>
                </a-col>
              </div>
              <a-col :md="24" :sm="24" v-if="model.status >= 2">
                <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="解决方案">
                  <a-textarea
                    :autoSize="{ minRows: 3, maxRows: 5 }"
                    placeholder="请输入解决方案"
                    v-decorator="['solution', {}]"
                    :disabled="disableSubmit&& !showCheck"
                  />
                </a-form-item>
              </a-col>

            </a-row>

            <a-row>
              <a-col>
                <iws-upload
                  ref="iwupload"
                  :options="{ btnText: '上传附件', title: '附件' }"
                  :disableSubmit="attachmentsDisabled"
                  :isDrag="!attachmentsDisabled"
                  accept=""
                  filesrc="om_job_order"
                  :srcid="this.model.id"
                ></iws-upload>
              </a-col>
            </a-row>

            <div class="drawer-msg" v-show="disableSubmit && !showCheck">
              <a-row>
                <a-col :span="12"> 创建信息：{{ model.createBy_userName }} （{{ model.createTime }}）</a-col>
                <a-col :span="12" v-if="model.updateBy_userName">
                  最后修改信息：{{ model.updateBy_userName }} （{{ model.updateTime }}）
                </a-col>
              </a-row>
            </div>
            <div class="drawer-tool" v-show="showCheck || !disableSubmit">
              <a-button icon="close" @click="handleCancel">取消</a-button>
              <a-button type="primary" v-if="!showEdit" :disabled="!networkStatus" icon="check" @click="handleOk(1)"
                >确定
              </a-button>
              <a-button
                type="primary"
                v-if="model.status == 1 && showEdit && isAssignedUser"
                :disabled="!networkStatus || confirmLoading"
                icon="check"
                @click="handleOk(2)"
                >开始处理
              </a-button>
              <a-button
                type="primary"
                v-if="model.status == 2 && showEdit && isAssignedUser"
                :disabled="!networkStatus || confirmLoading"
                icon="check"
                @click="handleOk(3)"
                >完成处理
              </a-button>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="评论" key="2" v-if="model.id">
            <comment-drawer :originId="model.id" :originKey="'om_job_order'" v-if="visible"></comment-drawer>
          </a-tab-pane>
        </a-tabs>
      </a-form>
    </a-spin>
    <select-asset-modal ref="AssetListModal" @selectProduct="choseProduct"></select-asset-modal>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage'
import { ModalFormMixin } from '@/mixins/ModalFormMixin'
import pick from 'lodash.pick'
import moment from 'moment'
import { queryUserTreeList } from '@/api/api'
import SelectAssetModal from '../../../assets/SelectAssetModal'
import CommentDrawer from './CommentDrawer.vue'
import IwsUpload from '@comp/upload/IwsUpload'

export default {
  name: 'JobOrderModal',
  mixins: [ModalFormMixin],
  components: {
    SelectAssetModal,
    CommentDrawer,
    IwsUpload,
  },
  data() {
    return {
      title: '派工单表单',
      siteName: '',
      /* 站点ID*/
      siteId: null,
      operationType: null,
      tableName: 'om_job_order',
      form_fields: [
        'siteId',
        'originId',
        'originKey',
        'tenantId',
        'userId',
        'category',
        'jobLevel',
        'assetId',
        'errorCode',
        'remark',
        'title',
        'solution',
        'status',
      ],
      form_fields_time: ['startTime', 'endTime', 'completionTime','processingTime'],
      validatorRules: {
        userId: { rules: [{ required: true, message: '请选择处理人员!' }] },
        category: { rules: [{ required: true, message: '请选择任务类型' }] },
        jobLevel: { rules: [{ required: true, message: '请选择任务级别' }] },
        title: { rules: [{ required: true, message: '请输入标题!' }] },
        originKey: { rules: [{ required: true, message: '请选择故障来源!' }] },
      },
      url: {
        add: '/om/job/order',
      },
      userTree: [], //人员信息
      selectedAsset: [],
      assetIds: [],
    }
  },
  props: ['pagePath'],
  computed: {
    isAssignedUser() {
      const userId = this.$store.getters.userInfo.id
      return userId != null && this.model.userId != null && String(this.model.userId) === String(userId)
    },
    attachmentsDisabled() {
      return this.showCheck ? !(this.isAssignedUser && this.model.status == 2) : this.disableSubmit
    },
  },
  watch: {
    currentSiteName(newVal, oldVal) {
      this.siteName = newVal
    },
    currentSiteId(newVal) {
      this.siteId = newVal
    },
  },
  created() {
    this.siteName = sessionStorage.getItem('siteName')
  },
  methods: {
    add(originKey) {
      this.edit(originKey)
    },

    edit(record) {
      // debugger
      this.visible = true
      this.$nextTick(()=>{
        this.form.resetFields()
        this.model = Object.assign({}, record)
        this.model.siteId = this.siteId ? this.siteId : this.model.siteId

        /*this.model.siteName = this.siteName
          this.model.siteId = sessionStorage.getItem('siteId')
          this.model.operationType = sessionStorage.getItem('operationType')*/
        // debugger
        // if (this.model.id) {
        //
        // } else {
        //   debugger
        //   this.model.siteId = this.siteId
        //   this.model.siteName = this.siteName
        //   this.model.operationType = this.operationType
        //   this.model.title = ''
        //   this.model.errorCode = ''
        //   console.log('this.model', this.model)
        // }

        console.log('this.model', this.model)
        this.$nextTick(() => {
          this.loadTreeList()
          this.selectedAsset = []
          this.assetIds = []
          this.disableSubmit = this.showCheck ? true : this.disableSubmit
          if (this.model.id || this.addJob) {
            this.assetIds = this.model.assetId ? this.model.assetId : null
            this.model.productName = this.model.productName ? this.model.productName : null
            this.selectedAsset.push(this.model.productName)
            this.siteName = this.model.siteName
          } else {
            // this.model.startTime = new Date().toLocaleDateString()
          }



          var that = this
          that.form.setFieldsValue(pick(that.model, that.form_fields))
          //时间格式化
          let timeVal = {}
          that.form_fields_time.forEach((item, index) => {
            timeVal[item] = that.model[item] ? moment(that.model[item]) : null
          })
          that.form.setFieldsValue(timeVal)
          console.log('that.form', that.form)
          that.$refs.iwupload.loadUploadFiles()
        })
      })

    },
    //加载人员信息
    loadTreeList() {
      var that = this
      that.userTree = []
      // 用户
      queryUserTreeList().then((res) => {
        if (res.success) {
          that.userTree = res.result
        }
      })
    },
    selectAssets() {
      // this.$refs.AssetListModal.siteId = this.currentSiteId
      this.$refs.AssetListModal.siteId = this.model.siteId
      this.$refs.AssetListModal.disableSubmit = true
      this.$refs.AssetListModal.add(this.selectedAsset, this.assetIds)
    },
    // 子modal回调
    choseProduct: function (productList) {
      this.selectedAsset = []
      this.assetIds = []
      for (var i = 0; i < productList.length; i++) {
        this.selectedAsset.push(productList[i].productName)
        this.assetIds = productList[i].id
      }
    },
    handleOk(s) {
      if ((s === 2 || s === 3) && !this.isAssignedUser) {
        this.$message.warning('您不是该工单的处理人，无法办理')
        return
      }
      const upload = this.$refs.iwupload
      if (upload.uploading || upload.myfileList.some(file => file.status === 'uploading')) {
        this.$message.warning('附件正在上传，请上传完成后再提交')
        return
      }
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let formData = Object.assign(that.model, values)
          //时间格式化
          formData.endTime = formData.endTime ? formData.endTime.format('YYYY-MM-DD HH:mm:ss') : null
          formData.startTime = formData.startTime ? formData.startTime.format('YYYY-MM-DD HH:mm:ss') : null
          formData.completionTime = formData.completionTime
            ? moment(formData.completionTime).format('YYYY-MM-DD HH:mm:ss')
            : null
          formData.processingTime = formData.processingTime
            ? moment(formData.processingTime).format('YYYY-MM-DD HH:mm:ss')
            : null

          if (this.model.id && this.model.status == 1 && this.model.userId==this.$store.getters.userInfo.id) {
            formData.processingTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.model.id && this.model.status == 2) {
            formData.completionTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
          }

          formData.assetId = that.assetIds && (that.assetIds == [] || that.assetIds.length == 0) ? '' : that.assetIds
          formData.siteId = formData.siteId ? formData.siteId : this.model.siteId
          formData.changeStatus = !formData.status ? 1 : s == 2 ? 2 : s == 3 ? 3 : s == 1 ? formData.status : 1
          formData = this.$refs.iwupload.getUploadListToFromData(formData)
          let httpurl = '',
            method = ''
          if (!this.model.id) {
            httpurl = this.url.add ? this.url.add : this.pagePath
            method = 'post'
          } else {
            httpurl = this.url.edit ? this.url.edit : this.pagePath
            method = 'put'
          }
          console.log('formData',formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$notification.success({ message: res.message })
                that.$emit('ok')
                that.close()
              } else {
                that.$notification.warning({ message: res.message })
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>
